<div
  class="icon-container"
  [class.pdf]="format === 'pdf'"
  [class.png]="format === 'png'"
  [class.jpg]="format === 'jpg' || format === 'jpeg'"
>
  <span>{{ format }}</span>
</div>
